import { PermissoesService } from './../../../service/usuario/permissoes.service';
import { element } from 'protractor';
import { AplicabilidadeService } from './../../../service/produto/aplicabilidade.service';
import { PrecoService } from './../../../service/produto/preco.service';
import { GrupoProdutoService } from './../../../service/produto/grupo-produto.service';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormArray,
  FormControl,
} from '@angular/forms';
import { ResponsePageable } from 'app/model/cliente/pageable/responsePageable.model';
import { ProdutoService } from './../../../service/produto/produto.service';
import { ProdutoModel } from './../../../model/produto/produto.model';
import { AuthenticationService } from '@alfresco/adf-core';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { GrupoClienteModel } from 'app/model/cliente/grupocliente.model';
import { GrupoProdutoModel } from 'app/model/produto/grupo-produto.model';
import { PrecoModel } from 'app/model/produto/preco.model';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { AplicabilidadeModel } from 'app/model/produto/aplicabilidade.mode';
import * as CryptoJS from 'crypto-js';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

export interface Aplicabilidade {
  descricaoCategoriaProduto: string;
}

@Component({
  selector: 'app-produto',
  templateUrl: './produto.component.html',
  styleUrls: ['./produto.component.scss'],
})
export class ProdutoComponent implements OnInit {
  toppings = new FormControl();

  toppingList: string[] = ['Movimentação', 'Transporte'];
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  colapse = false;
  adm = true;
  acervo = false;
  solicitacao = false;
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  aplicabilidadeChips: Aplicabilidade[] = [];

  produto = {} as ProdutoModel;
  produtos: ProdutoModel[];

  produtoarquivado = {} as ProdutoModel;
  produtoarquivados: ProdutoModel[];
  pagearquivado: ResponsePageable;

  preco = {} as PrecoModel;
  precos: PrecoModel[];

  precoproduto = {} as PrecoModel;
  precoprodutos: PrecoModel[];

  aplicabilidade = {} as AplicabilidadeModel;
  aplicabilidades: AplicabilidadeModel[];

  aplicabilidadeDescricao = {} as AplicabilidadeModel;
  aplicabilidadeDescricoes: AplicabilidadeModel[];
  aplicabilidadesDescricao: any[];

  grupoProduto = {} as GrupoProdutoModel;
  grupoProdutos: GrupoProdutoModel[];

  apagou = false;

  precoPadraoPorProduto = {} as PrecoModel;
  public testePrecoPadrao = false;

  public page: ResponsePageable;
  public pageAtual = 0;
  public pageAtualPreco = 0;
  public formProduto: FormGroup;
  public submit = false;
  public edit = false;

  public edited = false;
  public editado = false;
  public errorAlert = false;
  public successDelete = false;
  public successDelete2 = false;
  public successDelete3 = false;
  public erroPreco = false;

  viewProduto = false;
  deleteProduto = false;
  editProduto = false;
  createProduto = false;
  superUser = false;
  arquivarDesarquivar = false;
  arrayString: string;

  selectedMovimentacao: boolean = false;
  selectedTransporte: boolean = false;
  idDoPreco;
  user: any;
  userAdmin = false;
  userUser = false;
  userEditor = false;
  userCreator = false;

  @ViewChild('cardEdit') targetEl: ElementRef;

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private _snackBar: MatSnackBar,
    private produtoService: ProdutoService,
    private fb: FormBuilder,
    private grupoProdutoService: GrupoProdutoService,
    private precoService: PrecoService,
    private permissionService: PermissoesService,
    private aplicabilidadeService: AplicabilidadeService
  ) {}

  ngOnInit() {
    //Formulário de Produtos e/ou Serviços
    this.formProduto = this.fb.group({
      id: [''],
      cod: ['', Validators.maxLength(8)],
      descricao: ['', Validators.maxLength(50)],
      peso: ['', Validators.maxLength(10)],
      selectedMovimentacao: [false],
      selectedTransporte: [false],
      altura: ['', Validators.maxLength(10)],
      largura: ['', Validators.maxLength(10)],
      profundidade: ['', Validators.maxLength(10)],
      empMaximo: ['', Validators.maxLength(10)],
      recipienteAlocacao: [false],
      qtsAlocavel: ['', Validators.required],
      aliqICMS: ['', Validators.required],
      grupoProdutoServico: [GrupoClienteModel, Validators.required],
      precoProdutoServicos: this.fb.array([this.addFormPrecos()]),
    });

    this.listPageProdutos(0, 10);
    this.getGrupos();
    this.getPrecos(0, 10);
    this.listPageProdutosInativos(0, 10);
    this.getAuthority();
  }

  scroll() {
    this.targetEl.nativeElement.scrollIntoView();
  }

  getPrecosArray(form) {
    return form.controls.precoProdutoServicos.controls;
  }

  get precoProdutoServicos() {
    return this.formProduto.controls['precoProdutoServicos'].get(
      'aplicabilidades'
    ) as FormArray;
  }

  addPrecoProdutoServicos() {
    this.precoProdutoServicos.controls['aplicabilidades'];
  }

  add(event: MatChipInputEvent): void {
    console.log(event);
    const input = event.input;
    const value = event.value;
    // Add our fruit
    if ((value || '').trim()) {
      this.aplicabilidadeChips.push({
        descricaoCategoriaProduto: value.trim(),
      });

      const categorizacao = this.formProduto.controls.precoProdutoServicos[
        'controls'
      ][0].controls.aplicabilidades;
      categorizacao.push(
        new FormControl({ descricaoCategoriaProduto: value.trim() })
      );
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  remove(aplicabilidade: Aplicabilidade): void {
    const index = this.aplicabilidadeChips.indexOf(aplicabilidade);

    const categorizacao = this.formProduto.controls.precoProdutoServicos[
      'controls'
    ][0].controls.aplicabilidades;

    if (index >= 0) {
      this.aplicabilidadeChips.splice(index, 1);

      categorizacao.removeAt(index);
    }
  }

  addFormPrecos(): FormGroup {
    return this.fb.group({
      id: [''],
      cod: ['', Validators.maxLength(10)],
      precoUtilizacao: ['', Validators.maxLength(15)],
      precoArmazenagem: ['', Validators.maxLength(15)],
      selectedMovimentacao: [false],
      selectedTransporte: [false],
      precoMovimentacaoImplantacao: ['', Validators.maxLength(15)],
      precoMovimentacaoEntrada: ['', Validators.maxLength(15)],
      precoMovimentacaoSaidaNormal: ['', Validators.maxLength(15)],
      precoMovimentacaoSaidaUrgente: ['', Validators.maxLength(15)],
      precoTransporteImplantacao: ['', Validators.maxLength(15)],
      precoTransporteEntrada: ['', Validators.maxLength(15)],
      precoTransporteSaidaNormal: ['', Validators.maxLength(15)],
      precoTransporteSaidaUrgente: ['', Validators.maxLength(15)],
      precoPadrao: [false],
      aplicabilidades: this.fb.array([]),
    });
  }

  addFormAplicabilidade(): FormGroup {
    return this.fb.group({
      descricaoCategoriaProduto: new FormControl(),
    });
  }

  clickNovoProduto() {
    this.produto.id = undefined;
    this.getDados();
    this.selectedMovimentacao = false;
    this.selectedTransporte = false;
  }

  getDados() {
    this.getGrupos();
    this.postSubmit();
    this.precoprodutos = [];
    this.precoPadraoPorProduto = {} as PrecoModel;
    this.testePrecoPadrao = false;
    //this.aplicabilidadeChips = [];
  }

  changePage(event) {
    this.listPageProdutos(event.page, event.size);
    this.pageAtual = event.page;
  }

  changePageInativo(event) {
    this.listPageProdutosInativos(event.page, event.size);
  }

  changePagePreco(event) {
    this.listPrecosPorCod(event.page, event.size, this.produto.id);
    this.pageAtualPreco = event.page;
  }

  onSubmit() {
    this.submit = true;
  }

  setAplicabilidades() {
    const categorizacao = this.aplicabilidadeChips;
    categorizacao.forEach((apl) =>
      this.formProduto.controls.precoProdutoServicos[
        'controls'
      ][0].controls.aplicabilidades.push(new FormControl(apl))
    );
  }

  postSubmit() {
    this.submit = false;
    this.formProduto.reset();
    const categorizacao = this.formProduto.controls.precoProdutoServicos[
      'controls'
    ][0].controls.aplicabilidades;
    while (categorizacao.length !== 0) {
      categorizacao.removeAt(0);
    }
  }

  compararEditProduto(obj1, obj2) {
    return obj1 && obj2
      ? obj1.descricao === obj2.descricao && obj1.id === obj2.id
      : obj1 === obj2;
  }

  getGrupos() {
    this.grupoProdutoService.getGrupoProduto().subscribe((data) => {
      this.grupoProdutos = data.content;
    });
  }

  getPrecos(page, size) {
    this.precoService.getPagePreco(page, size).subscribe((data) => {
      this.page = data;
      this.precos = this.page.content;
    });
  }

  tabClick(tab) {
    if (tab.index == 0) {
      return this.listPageProdutos(0, 10);
    } else if (tab.index == 1) {
      return this.listPageProdutosInativos(0, 10);
    }
  }

  listPageProdutos(page, size) {
    this.produtoService.getPageProduto(page, size).subscribe((data) => {
      this.page = data;
      this.produtos = this.page.content;
    });
  }

  listPageProdutosInativos(page, size) {
    this.produtoService.getPageProdutoInativo(page, size).subscribe((data) => {
      this.pagearquivado = data;
      this.produtoarquivados = this.pagearquivado.content;
    });
  }

  listAplicabilidadesPreco(id: number) {
    this.aplicabilidadeService
      .getAplicabilidadePorIdPreco(id)
      .subscribe((data) => {
        this.aplicabilidades = data.content;
      });
  }

  listDescricaoAplicabilidadesPorIdPreco(id: number) {
    this.aplicabilidadeService
      .getAplicabilidadeDesciaoPorIdPreco(id)
      .subscribe((data) => {
        this.aplicabilidadeDescricoes = data;
        this.aplicabilidadesDescricao = data;
        this.aplicabilidadeChips = data;

        const categorizacao = this.formProduto.controls.precoProdutoServicos[
          'controls'
        ][0].controls.aplicabilidades;
        data.forEach((element) => {
          categorizacao.push(
            new FormControl({
              descricaoCategoriaProduto: element.descricaoCategoriaProduto,
            })
          );
        });
      });
  }

  listPrecosPorCod(page, size, id: number) {
    this.precoService
      .getPrecosPorCodProduto(page, size, id)
      .subscribe((data) => {
        this.page = data;
        this.precoprodutos = this.page.content;
      });
  }

  getPrecoPadrao(id: number) {
    this.precoService.getPrecoPadraoPorProduto(id).subscribe(
      (data) => {
        this.precoPadraoPorProduto = data;
        this.testePrecoPadrao = true;
        this.idDoPreco = data.id;
        this.listDescricaoAplicabilidadesPorIdPreco(data.id);
      },
      () => {
        this.precoPadraoPorProduto = {} as PrecoModel;
        this.testePrecoPadrao = false;
      }
    );
  }

  getDadosPreco(precoProduto: PrecoModel) {
    this.precoproduto = { ...precoProduto };
    this.selectedMovimentacao = true;
    this.selectedTransporte = true;
    //console.log(precoProduto);
    this.listDescricaoAplicabilidadesPorIdPreco(precoProduto.id);
    const idPreco = this.formProduto.controls.precoProdutoServicos[
      'controls'
    ][0].controls.id;
    idPreco.setValue(this.precoPadraoPorProduto.id);
  }

  saveOrEditProduto() {
    const precoA = this.formProduto.get('precoProdutoServicos').value[0].precoArmazenagem;
    const precoU = this.formProduto.get('precoProdutoServicos').value[0].precoUtilizacao;
    if (precoA === null || precoU === null) {
      this.openSnackBarError('Erro! Preencha os campos obrigatórios.');
    } else {
      if (this.produto.id !== undefined) {
        this.editarProduto();
      } else {
        this.adicionarProdutoComPreco();
      }
    }

  }

  adicionarProdutoComPreco() {
    this.produtoService.postProdutoWithPreco(this.formProduto.value).subscribe(
      (data) => {
        this.produto = new ProdutoModel();
        this.postSubmit();
        this.aplicabilidadeChips = [];
        this.openSnackBarSuccess('Produto salvo com sucesso !');
        this.listPageProdutos(0, 10);
      },
      (error) => {
        console.log(error);
        this.openSnackBarError('Erro ao tentar salvar o Produto !');
      }
    );
  }

  adicionarProduto() {
    this.produtoService.postProduto(this.formProduto.value).subscribe(
      (data) => {
        this.produto = new ProdutoModel();
        this.postSubmit();
        this.openSnackBarSuccess('Produto salvo com sucesso !');
        this.listPageProdutos(0, 10);
      },
      (error) => {
        console.error(error);
        this.openSnackBarError('Erro ao tentar salvar o Produto !');
      }
    );
  }

  putProduto(produto: ProdutoModel) {
    this.produto = { ...produto };
    this.formProduto
      .get('grupoProdutoServico')
      .setValue(produto.grupoProdutoServico);
    this.formProduto.get('id').setValue(produto.id);
    this.edit = true;
    this.getPrecoPadrao(produto.id);
  }

  confirme(id: number) {
    var confirme = confirm('Deseja excluir este preço ?');
    if (confirme == true) {
      this.deletePreco(id);
    } else {
      console.log('cancelou exclusão');
    }
  }

  deletePreco(id: number) {
    this.precoService.deletePreco(id).subscribe(
      () => {
        this.apagou = true;
        this.openSnackBarSuccess('Preço excluído com sucesso !');
      },
      (err) => {
        console.log(err);
        this.openSnackBarError('Erro ao tentar excluir o Preço !')
      }
    );
  }

  resetPrecoPadrao() {
    this.precoPadraoPorProduto = {} as PrecoModel;
    this.aplicabilidadeChips = [];
    this.formProduto.reset();
    const categorizacao = this.formProduto.controls.precoProdutoServicos[
      'controls'
    ][0].controls.aplicabilidades;
  }

  editarProduto() {
    if (this.idDoPreco !== null) {
      console.log(this.formProduto.get('precoProdutoServicos'));
      const ControlIdPreco = this.formProduto.controls.precoProdutoServicos['controls'][0].controls.id
      ControlIdPreco.setValue(this.idDoPreco);
    }
    console.log(this.formProduto.value);
    this.produtoService.putProduto(this.formProduto.value).subscribe(
      (data) => {
        this.listPageProdutos(this.pageAtual, 10);
        this.openSnackBarSuccess('Produto atualizado com sucesso !');
        this.postSubmit();
        this.getPrecoPadrao(this.produto.id);
      },
      (error) => {
        console.error(error);
        this.openSnackBarError('Erro ao tentar atualizar o Produto !');
      }
    );
  }

  getOneProduto(cod: number) {
    this.produtoService.getProdutoUnico(cod).subscribe(
      (data) => {},
      (error) => {
        console.error(error);
      }
    );
  }

  confirmeExcluir(id: number) {
    var confirme = confirm('Deseja excluir este produto permanentemente ?');
    if (confirme == true) {
      this.apagarProduto(id);
    } else {
      console.log('cancelou exclusão');
    }
  }

  apagarProduto(id: number) {
    this.produtoService.deleteProduto(id).subscribe(
      () => {
        this.produto = new ProdutoModel();
        this.openSnackBarSuccess('Produto excluído com sucesso !');
        this.listPageProdutosInativos(0, 10);
      },
      (error) => {
        this.openSnackBarError('Erro ao tentar excluir o Produto !');
      }
    );
  }

  confirmeArquivar(id: number) {
    var confirme = confirm('Deseja arquivar este produto?');
    if (confirme == true) {
      this.arquivarProduto(id);
    } else {
      console.log('Cancelou exclusão');
    }
  }

  arquivarProduto(id: number) {
    this.produtoService.inativarProduto(id).subscribe(
      () => {
        this.openSnackBarSuccess('Produto arquivado com sucesso !');
        this.listPageProdutos(0, 10);
      },
      (error) => {
        console.error(error);
        this.openSnackBarError('Erro ao tentar arquivar o Produto !');
      }
    );
  }

  ativarProduto(id: number) {
    this.produtoService.ativarProduto(id).subscribe(
      () => {
        this.openSnackBarSuccess('Produto ativado com sucesso !');
        this.listPageProdutosInativos(0, 10);
      },
      (error) => {
        console.error(error);
        this.openSnackBarError('Erro ao tentar aticar o Produto !');
      }
    );
  }

  getAuthority() {
    this.getItemAuthority('authority');
      if (this.arrayString.includes('LIST_PRODUTO')) {
        this.viewProduto = true;
      }
      if (this.arrayString.includes('DELETE_PRODUTO')) {
        this.deleteProduto = true;
      }
      if (this.arrayString.includes('EDIT_PRODUTO')) {
        this.editProduto = true;
      }
      if (this.arrayString.includes('ADD_PRODUTO')) {
        this.createProduto = true;
      }
      if (this.arrayString.includes('ARQUIVA_DESARQUIVA_PRODUTO')) {
        this.arquivarDesarquivar = true;
      }
      if (this.arrayString.includes('SUPER_USER')) {
        this.superUser = true;
      }
  }

  getItemAuthority(key) {
    const store = sessionStorage.getItem(key);
    if (store) {
        try {
            const bytes = CryptoJS.AES.decrypt(store, sessionStorage.getItem('ticket-ECM'));
            this.arrayString = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            return this.arrayString;
        } catch (e) {
            sessionStorage.clear();
        }
    }

    return null;
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message,'', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/produto-components/produto/produto.component.ts